const invoiceSuccessModalActionTypes = {
    INVOICE_APPROVED: 'INVOICE_APPROVED',
    INVOICE_DECLINED: 'INVOICE_DECLINED',
    SALES_INVOICE_CREATED: 'SALES_INVOICE_CREATED',
};

export default invoiceSuccessModalActionTypes;
